import { Col, Row, Typography } from "antd";
import { QueryClientProvider } from "@tanstack/react-query";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import ActionLogDrawerAsync from "@/v1/components/common/ActionLogDrawerAsync";
import { CreateConnectionButton } from "./components/create-connection";
import { ConnectionsOverview } from "./components/connections-overview";
import { queryClient } from "./client";
import { IUser } from "@/v1/types";
import {
  SectionHeaderTbody,
  SectionHeaderTd,
  Spacer,
  ViewLogsButton,
} from "../components/styles";

const getTexts = (t: TFunction) => ({
  title: t("title"),
  actionLogDrawer: {
    title: t("actionLogDrawer.title"),
    viewAuditLogs: t("actionLogDrawer.viewAuditLogs"),
  },
  noUserSelected: t("noUserSelected"),
});

export const BankingConnections = ({ user }: { user: IUser | undefined }) => {
  const { t } = useTranslation("Banking");
  const texts = getTexts(t);

  return (
    <QueryClientProvider client={queryClient}>
      <SectionHeaderTbody>
        <tr>
          <SectionHeaderTd colSpan={7}>
            <Row align="middle" justify="space-between">
              <Typography.Title level={3} style={{ margin: 0 }}>
                {texts.title}
              </Typography.Title>
              <Row align="middle" gutter={12} justify="end">
                {user && (
                  <>
                    <Col>
                      <CreateConnectionButton user={user} />
                    </Col>
                    <Col>
                      <ActionLogDrawerAsync
                        title={texts.actionLogDrawer.title}
                        modelName="banking_connection"
                        recordIds={[user.publicId]}
                        renderButton={({ onClick }) => (
                          <ViewLogsButton type="link" onClick={onClick}>
                            {texts.actionLogDrawer.viewAuditLogs}
                          </ViewLogsButton>
                        )}
                      />
                    </Col>
                  </>
                )}
              </Row>
            </Row>
          </SectionHeaderTd>
        </tr>
      </SectionHeaderTbody>
      {user ? (
        <ConnectionsOverview customerId={user.publicId} />
      ) : (
        <>
          <SectionHeaderTbody>
            <tr>
              <SectionHeaderTd colSpan={7}>
                <p style={{ margin: 0 }}>{texts.noUserSelected}</p>
              </SectionHeaderTd>
            </tr>
          </SectionHeaderTbody>
          <Spacer>
            <tr>
              <td>&nbsp;</td>
            </tr>
          </Spacer>
        </>
      )}
    </QueryClientProvider>
  );
};
